"use strict";
"use es6";
/**
 * An error thrown when one or more errors have occurred during the
 * `unsubscribe` of a {@link Subscription}.
 */

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnsubscriptionError = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/wrapNativeSuper"));

var UnsubscriptionError =
/*#__PURE__*/
function (_Error) {
  (0, _inherits2.default)(UnsubscriptionError, _Error);

  function UnsubscriptionError(errors) {
    var _this;

    (0, _classCallCheck2.default)(this, UnsubscriptionError);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UnsubscriptionError).call(this));
    _this.errors = errors;
    var err = Error.call((0, _assertThisInitialized2.default)(_this), errors ? errors.length + " errors occurred during unsubscription:\n  " + errors.map(function (err, i) {
      return i + 1 + ") " + err.toString();
    }).join('\n  ') : '');
    _this.name = err.name = 'UnsubscriptionError';
    _this.stack = err.stack;
    _this.message = err.message;
    return _this;
  }

  return UnsubscriptionError;
}((0, _wrapNativeSuper2.default)(Error));

exports.UnsubscriptionError = UnsubscriptionError;